import {
	Box,
	Button,
	ListItemIcon,
	ListItemText,
	MenuItem,
	MenuList,
	Paper,
	Typography,
} from '@mui/material';
import React, { memo, useEffect, useRef, useState } from 'react';
import ArrowDropDownSharpIcon from '@mui/icons-material/ArrowDropDownSharp';
import { Check } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { colors } from '../../theme/color-palette';

const TimePeriodFilter = memo((props) => {
	const { id, selectedOption, handleSelect, options, weekFilter } = props;
	const [open, setOpen] = useState(false);
	// const [value, setValue] = useState(selectedOption);

	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				event.stopPropagation();
				if (ref.current && !ref.current.contains(event.target)) {
					setOpen(false);
				}
			}
			// Bind the event listener

			document.addEventListener('click', handleClickOutside);
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener('click', handleClickOutside);
			};
		}, [ref]);
	};

	const wrapperRef = useRef(null);
	const buttonRef = useRef(null);
	useOutsideAlerter(wrapperRef);

	const isOptionDisabled = {
		Daily: !(weekFilter === 0 || weekFilter === 1),
		Weekly: weekFilter === 0 || weekFilter === 1,
		Monthly: weekFilter === 0 || weekFilter === 1,
	};

	return (
		<>
			<div data-testid="time-period"></div>
			<Button
				data-testid="time-period-dropdown"
				id={`${id}-dropdown`}
				ref={buttonRef}
				variant="text"
				onClick={(e) => {
					e.stopPropagation();
					setOpen(!open);
				}}
				sx={{
					textTransform: 'none',
					borderRadius: '100px',
					height: '32px',
					padding: '0 8px',
					color: '#2E2F32',
					':hover': {
						backgroundColor: 'transparent',
					},
					position: 'relative',
					display: 'flex',
					gap: '8px',
					justifyContent: 'flex-start',
					minWidth: 0,
					width: 'fit-content',
					'& .MuiButton-endIcon': {
						margin: 0,
					},
				}}
				endIcon={<ArrowDropDownSharpIcon fontSize="small" />}>
				<Typography
					sx={{
						color: colors.PURPLE_AI,
						fontSize: '12px',
						fontWeight: 400,
						lineHeight: '16px',
					}}>
					{selectedOption}
				</Typography>
			</Button>
			<Box
				ref={wrapperRef}
				sx={{
					display: open ? 'flex' : 'none',
					gap: '4px',
					zIndex: 100,
					position: 'absolute',
					// maxHeight: '340px',
					marginTop: `4px`,
					marginLeft: `10px`,
				}}>
				<Paper
					sx={{
						// padding: '8px',
						boxShadow:
							'0px -1px 3px 0px rgba(0, 0, 0, 0.10), 0px 3px 5px 2px rgba(0, 0, 0, 0.15)',
						borderRadius: '4px',
						maxWidth: '280px',
					}}>
					<MenuList
						dense
						data-testid="time-period-dropdown-menu"
						sx={{
							overflowY: 'scroll',
							maxHeight: '292px',
							overflow: 'auto',
							'& .MuiButtonBase-root': {
								display: 'flex !important',
								padding: '10px !important',
							},

							whiteSpace: 'nowrap',
						}}>
						{options?.map((option) => (
							<MenuItem
								sx={{
									display: 'block !important',
									padding: '4px 16px !important',
								}}
								disabled={isOptionDisabled[option]}
								onClick={() => {
									handleSelect(option);
									setOpen(false);
								}}
								value={option}
								key={option}>
								{selectedOption === option && (
									<ListItemIcon>
										<Check />
									</ListItemIcon>
								)}

								<ListItemText
									sx={{
										textAlign: 'start',
									}}
									inset={selectedOption !== option}>
									{option}
								</ListItemText>
							</MenuItem>
						))}
					</MenuList>
				</Paper>
			</Box>
		</>
	);
});

TimePeriodFilter.defaultProps = {
	id: 'time-period',
	options: [],
	selectedOption: '',
	handleSelect: () => '',
};

TimePeriodFilter.propTypes = {
	id: PropTypes.string,
	options: PropTypes.arrayOf(PropTypes.string),
	selectedOption: PropTypes.string,
	handleSelect: PropTypes.func,
	weekFilter: PropTypes.number,
};

TimePeriodFilter.displayName = 'TimePeriodFilter';

export default TimePeriodFilter;
